<template>
  <div class="pl-toolbar-actions" aria-label="Team actions">
    <div v-if="isSearchActive" class="pl-toolbar-actions__stats" role="list">
      <div class="pl-chip pl-chip--accent" role="listitem">
        <v-icon icon="mdi-magnify" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">Filtered</span>
      </div>
    </div>

    <div class="pl-toolbar-actions__buttons">
      <v-btn
        variant="flat"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--primary"
        prepend-icon="mdi-plus"
        :disabled="!isSessionReady"
        @click="$emit('add')"
      >
        Add Admin/Agent
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-refresh"
        :loading="loading"
        :disabled="!isSessionReady"
        @click="$emit('refresh')"
      >
        Refresh
      </v-btn>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'UsersHeader' })

defineProps({
  loading: { type: Boolean, default: false },
  isSessionReady: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['add', 'refresh'])
</script>
